import { render, staticRenderFns } from "./BerufUndAusbildung.vue?vue&type=template&id=275b64fa"
import script from "./BerufUndAusbildung.vue?vue&type=script&lang=js"
export * from "./BerufUndAusbildung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports